module.exports = __webpack_public_path__ + "img/investisseur.0d8dad92.jpeg";